export default [
  {
    "id": "mat-enem-0687",
    "numero": 2187,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Sabe-se que o valor cobrado na conta de ener-\ngia elétrica correspondente ao uso de cada ele-\ntrodoméstico é diretamente proporcional à po-\ntência utilizada pelo aparelho, medida em watts \n(W), e também ao tempo que esse aparelho \npermanece ligado durante o mês.  \n \nCerto consumidor possui um chuveiro elétrico \ncom potência máxima de 3600 W e um televisor \ncom potência máxima de 100 W. Em certo mês, \na família do consumidor utilizou esse chuveiro \nelétrico durante um tempo total de 5 horas e \nesse televisor durante um tempo total de 60 \nhoras, ambos em suas potências máximas. \n \nQual a razão entre o valor cobrado pelo uso do \nchuveiro e o valor cobrado pelo uso do televi-\nsor? \n \nA) 1:1 200 \nB) 1:12 \nC) 3:1 \nD) 36:1 \nE) 432:1",
    "alternativas": {
      "A": "1:1 200",
      "B": "1:12",
      "C": "3:1",
      "E": "432:1"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 687,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0688",
    "numero": 2188,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Um promotor de eventos foi a um supermercado \npara comprar refrigerantes para uma festa de \naniversário. Ele verificou que os refrigerantes \nestavam em garrafas de diferentes tamanhos e \npreços. A quantidade de refrigerante e o preço \nde cada garrafa, de um mesmo refrigerante, \nestão na tabela. \n \n \n \nPara economizar o máximo possível, o promotor \nde eventos deverá comprar garrafas que te-\nnham o menor preço por litro de refrigerante. O \npromotor de eventos deve comprar garrafas do \ntipo: \n \nA) I. \nB) II. \nC) III. \nD) IV. \nE) V.",
    "alternativas": {
      "B": "II.",
      "C": "III.",
      "E": "V.",
      "A": "I."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 688,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0689",
    "numero": 2189,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Uma pessoa, ao fazer uma pesquisa com al-\nguns alunos de um curso, coletou as idades dos \nentrevistados e organizou esses dados em um \ngráfico. \n \n \n \nQual a moda das idades, em anos, dos entrevis-\ntados? \n \nA) 9 \nB) 12 \nC) 13 \nD) 15 \nE) 21",
    "alternativas": {
      "A": "9",
      "B": "12",
      "C": "13",
      "D": "15"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 689,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0690",
    "numero": 2190,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Considere que os quarteirões de um bairro te-\nnham sido desenhados no sistema cartesiano, \nsendo a origem o cruzamento das duas ruas \nmais movimentadas desse bairro. Nesse dese- \nnho, as ruas têm suas larguras desconsideradas \ne todos os quarteirões são quadrados de mes-\nma área e a medida de seu lado é a unidade do \nsistema. \n \nA seguir há uma representação dessa situação, \nem que os pontos A, B, C e D representam es-\ntabelecimentos comerciais desse bairro. \n \n \n \nSuponha que uma rádio comunitária, de fraco \nsinal, garante área de cobertura para todo esta-\nbelecimento que se encontre num ponto cujas \ncoordenadas satisfaçam à inequação:  \n \nx² + y² – 2x – 4y – 31 ≤ 0. \n \nA fim de avaliar a qualidade do sinal, e propor-\ncionar uma futura melhora, a assistência técnica \nda rádio realizou uma inspeção para saber \nquais estabelecimentos estavam dentro da área \nde cobertura, pois estes conseguem ouvir a \nrádio enquanto os outros não. \n \nOs estabelecimentos que conseguem ouvir a \nrádio são apenas: \n \nA) A e C. \nB) B e C. \nC) B e D. \nD) A, B e C. \nE) B, C e D.",
    "alternativas": {
      "E": "B, C e D.",
      "B": "B e C.",
      "C": "B e D.",
      "D": "A, B e C."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 690,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0691",
    "numero": 2191,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "O fisiologista francês Jean Poiseuille estabele-\nceu, na primeira metade do século XIX, que o \nfluxo de sangue por meio de um vaso sanguí-\nneo em uma pessoa é diretamente proporcional \nà quarta potência da medida do raio desse va-\nso. Suponha que um médico, efetuando uma \nangioplastia, aumentou em 10% o raio de um \nvaso sanguíneo de seu paciente. \n \nO aumento percentual entre o fluxo por esse \nvaso está entre: \nA) 7% e 8% \nB) 9% e 11% \nC) 20% e 22% \nD) 39% e 41% \nE) 46% e 47%",
    "alternativas": {
      "E": "46% e 47%",
      "A": "7% e 8%",
      "C": "20% e 22%",
      "D": "39% e 41%"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 691,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0692",
    "numero": 2192,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Um bairro residencial tem cinco mil moradores, \ndos quais mil são classificados como vegetaria-\nnos. Entre os vegetarianos, 40% são esportis-\ntas, enquanto que, entre os não vegetarianos, \nessa porcentagem cai para 20%. Uma pessoa \ndesse bairro, escolhida ao acaso, é esportista. A \nprobabilidade de ela ser vegetariana é: \n \nA) 2/25 \nB) 1/5 \nC) 1/4 \nD) 1/3 \nE) 5/6",
    "alternativas": {
      "B": "1/5",
      "D": "1/3",
      "E": "5/6",
      "A": "2/25"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 692,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0693",
    "numero": 2193,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Na construção de um conjunto habitacional de \ncasas populares, todas serão feitas num mesmo \nmodelo, ocupando, cada uma delas, terrenos \ncujas dimensões são iguais a 20 m de compri-\nmento por 8 m de largura. Visando a comerciali-\nzação dessas casas, antes do início das obras, \na empresa resolveu apresentá-las por meio de \nmaquetes construídas numa escala de 1 : 200. \n \nAs medidas do comprimento e da largura dos \nterrenos, respectivamente, em centímetros, na \nmaquete construída, foram de: \n \nA) 4 e 10. \nB) 5 e 2. \nC) 10 e 4. \nD) 20 e 8. \nE) 50 e 20.",
    "alternativas": {
      "C": "10 e 4.",
      "E": "50 e 20.",
      "A": "4 e 10.",
      "B": "5 e 2."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 693,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0694",
    "numero": 2194,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Durante um jogo de futebol foram anunciados \nos totais do público presente e do público pa-\ngante. Diante da diferença entre os dois totais \napresentados, um dos comentaristas esportivos \npresentes afirmou que apenas 75% das pesso-\nas que assistiam àquele jogo no estádio paga-\nram ingresso. \n \nConsiderando que a afirmativa do comentarista \nestá correta, a razão entre o público não pagan-\nte e o público pagante naquele jogo foi: \n \nA) 1/4 \nB) 1/3 \nC) 3/4 \nD) 4/3 \nE) 3/1",
    "alternativas": {
      "A": "1/4",
      "B": "1/3",
      "C": "3/4",
      "D": "4/3"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 694,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0695",
    "numero": 2195,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Os maias desenvolveram um sistema de nume-\nração vigesimal que podia representar qualquer \nnúmero inteiro, não negativo, com apenas três \nsímbolos. Uma concha representava o zero, um \nponto representava o número 1 e uma barrinha \nhorizontal, o número 5. Até o número 19, os \nmaias representavam os números como mostra \na Figura 1: \n \n \n \n \n \nNúmeros superiores a 19 são escritos na verti-\ncal, seguindo potências de 20 em notação posi-\ncional, como mostra a Figura 2. \n \nOu seja, o número que se encontra na primeira \nposição é multiplicado por 200 = 1, o número \nque se encontra na segunda posição é multipli-\ncado por 201 = 20 e assim por diante. Os resul-\ntados obtidos em cada posição são somados \npara obter o número no sistema decimal. \n \nUm arqueólogo achou o hieróglifo da Figura 3 \nem um sítio arqueológico: \n \n \nO número, no sistema decimal, que o hieróglifo \nda Figura 3 representa é igual a: \n \nA) 279. \nB) 539. \nC) 2619. \nD) 5219. \nE) 7613.",
    "alternativas": {
      "B": "539.",
      "C": "2619.",
      "D": "5219.",
      "E": "7613."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 695,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0696",
    "numero": 2196,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Uma fábrica que trabalha com matéria-prima de \nfibra de vidro possui diversos modelos e tama-\nnhos de caixa-d’água. Um desses modelos é \num prisma reto com base quadrada. Com o \nobjetivo de modificar a capacidade de armaze-\nnamento de água, está sendo construído um \nnovo modelo, com as medidas das arestas da \nbase duplicadas, sem a alteração da altura, \nmantendo a mesma forma. \n \nEm relação ao antigo modelo, o volume do novo \nmodelo é: \n \nA) oito vezes maior. \nB) quatro vezes maior. \nC) duas vezes maior. \nD) a metade. \nE) a quarta parte.",
    "alternativas": {
      "D": "a metade.",
      "E": "a quarta parte.",
      "A": "oito vezes maior.",
      "B": "quatro vezes maior."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 696,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0697",
    "numero": 2197,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Uma fábrica vende pizzas congeladas de tama-\nnhos médio e grande, cujos diâmetros são res-\npectivamente 30 cm e 40 cm. Fabricam-se ape-\nnas pizzas de sabor muçarela. Sabe-se que o \ncusto com os ingredientes para a preparação é \ndiretamente proporcional ao quadrado do diâ-\nmetro da pizza, e que na de tamanho médio \nesse custo é R$ 1,80. Além disso, todas possu-\nem um custo fixo de R$3,80, referente às de-\nmais despesas da fábrica. Sabe-se ainda que a \nfábrica deseja lucrar R$ 2,50 em cada pizza \ngrande. \n \nQual é o preço que a fábrica deve cobrar pela \npizza grande, a fim de obter o lucro desejado? \n \nA) R$ 5,70 \nB) R$ 6,20 \nC) R$ 7,30 \nD) R$ 7,90 \nE) R$ 8,70",
    "alternativas": {
      "B": "R$ 6,20",
      "D": "R$ 7,90",
      "E": "R$ 8,70",
      "A": "R$ 5,70"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 697,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0698",
    "numero": 2198,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "No jogo mostrado na figura, uma bolinha desco-\nla-se somente de duas formas: ao longo de \nlinhas retas ou por arcos de circunferências \ncentradas no ponto O e raios variando de 1 a 8. \nDurante o jogo, a bolinha que estiver no ponto P \ndeverá realizar a seguinte sequência de movi-\nmentos: 2 unidades no mesmo sentido utilizado \npara ir do ponto O até o ponto A e, no sentido \nanti-horário, um arco de circunferência cujo \nângulo central é 120°. \n \n \n \nApós a sequência de movimentos descrita, a \nbolinha estará no ponto: \n \nA) B. \nB) D. \nC) E. \nD) F. \nE) G.",
    "alternativas": {
      "C": "E.",
      "D": "F.",
      "A": "B.",
      "B": "D."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 698,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0699",
    "numero": 2199,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "O banheiro de uma escola pública, com paredes \ne piso em formato retangular, medindo 5 metros \nde largura, 4 metros de comprimento e 3 metros \nde altura, precisa de revestimento no piso e nas \nparedes internas, excluindo a área da porta, que \nmede 1 metro de largura por 2 metros de altura. \nApós uma tomada de preços com cinco forne-\ncedores, foram verificadas as seguintes combi-\nnações de azulejos para as paredes e de lajotas \npara o piso, com os preços dados em reais por \nmetro quadrado, conforme a tabela. \n \n \n \nDesejando-se efetuar a menor despesa total, \ndeverá ser escolhido o fornecedor: \nA) A. \nB) B. \nC) C. \nD) D. \nE) E.",
    "alternativas": {
      "D": "D.",
      "A": "A.",
      "B": "B.",
      "C": "C."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 699,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0700",
    "numero": 2200,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Um protocolo tem como objetivo firmar acordos \ne discussões internacionais para conjuntamente \nestabelecer metas de redução de emissão de \ngases de efeito estufa na atmosfera.  \n \nO quadro mostra alguns dos países que assina-\nram o protocolo, organizados de acordo com o \ncontinente ao qual pertencem. \n \n \n \nEm um dos acordos firmados, ao final do ano, \ndois dos países relacionados serão escolhidos \naleatoriamente, para verificar se as metas de \nredução do protocolo estão sendo praticadas. \n \nA probabilidade de o primeiro país escolhido \npertencer à América do Norte e o segundo per-\ntencer ao continente asiático é: \n \nA) 1/9 \nB) 1/4 \nC) 3/10 \nD) 2/3 \nE) 1",
    "alternativas": {
      "D": "2/3",
      "E": "1",
      "B": "1/4",
      "C": "3/10"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 700,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0701",
    "numero": 2201,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Ao se perfurar um poço no chão, na forma de \num cilindro circular reto, toda a terra retirada é \namontoada na forma de um cone circular reto, \ncujo raio da base é o triplo do raio do poço e a \naltura é 2,4 metros.  \n \nSabe-se que o volume desse cone de terra é \n20% maior do que o volume do poço cilíndrico, \npois a terra fica mais fofa após ser escavada. \n \nQual é a profundidade, em metros, desse poço? \n \nA) 1,44 \nB) 6,00 \nC) 7,20 \nD) 8,64 \nE) 36,00",
    "alternativas": {
      "E": "36,00",
      "A": "1,44",
      "B": "6,00",
      "D": "8,64"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 701,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0702",
    "numero": 2202,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Uma confecção possuía 36 funcionários, alcan-\nçando uma produtividade de 5400 camisetas \npor dia, com uma jornada de trabalho diária dos \nfuncionários de 6 horas. Entretanto, com o lan-\nçamento da nova coleção e de uma nova cam-\npanha de marketing, o número de encomendas \ncresceu de forma acentuada, aumentando a \ndemanda diária para 21600 camisetas. Buscan-\ndo atender essa nova demanda, a empresa \naumentou o quadro de funcionários para 96. \nAinda assim, a carga horária de trabalho neces-\nsita ser ajustada. \n \nQual deve ser a nova jornada de trabalho diária \ndos funcionários para que a empresa consiga \natender a demanda? \n \nA) 1 hora e 30 minutos. \nB) 2 horas e 15 minutos. \nC) 9 horas. \nD) 16 horas. \nE) 24 horas.",
    "alternativas": {
      "E": "24 horas.",
      "A": "1 hora e 30 minutos.",
      "B": "2 horas e 15 minutos.",
      "C": "9 horas."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 702,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0703",
    "numero": 2203,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Na imagem, a personagem Mafalda mede a \ncircunferência do globo que representa o plane-\nta Terra. \n \n \n \nEm uma aula de matemática, o professor consi-\ndera que a medida encontrada por Mafalda, \nreferente à maior circunferência do globo, foi de \n80 cm. Além disso, informa que a medida real \nda maior circunferência da Terra, a linha do \nEquador, é de aproximadamente 40000 km. \n \nA circunferência da linha do Equador é quantas \nvezes maior do que a medida encontrada por \nMafalda? \n \nA) 500 \nB) 5000 \nC) 500000 \nD) 5000000 \nE) 50000000",
    "alternativas": {
      "E": "50000000",
      "A": "500",
      "B": "5000",
      "C": "500000"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 703,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0704",
    "numero": 2204,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "O prefeito de uma cidade deseja promover uma \nfesta popular no parque municipal para come-\nmorar o aniversário de fundação do município. \nSabe-se que esse parque possui formato retan-\ngular, com 120 m de comprimento por 150 m de \nlargura. Além disso, para segurança das pesso-\nas presentes no local, a polícia recomenda que \na densidade média, num evento dessa nature-\nza, não supere quatro pessoas por metro qua-\ndrado. \n \nSeguindo as recomendações de segurança \nestabelecidas pela polícia, qual é o número \nmáximo de pessoas que poderão estar presen-\ntes na festa? \n \nA) 1000 \nB) 4500 \nC) 18000 \nD) 72000 \nE) 120000",
    "alternativas": {
      "A": "1000",
      "B": "4500",
      "C": "18000",
      "D": "72000"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 704,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0705",
    "numero": 2205,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Um meio de transporte coletivo que vem ga-\nnhando espaço no Brasil é a van, pois realiza, \ncom relativo conforto e preço acessível, quase \ntodos os tipos de transportes: escolar e urbano, \nintermunicipal e excursões em geral. \n \nO dono de uma van, cuja capacidade máxima é \nde 15 passageiros, cobra para uma excursão \naté a capital de seu estado R$60,00 de cada \npassageiro. Se não atingir a capacidade máxi-\nma da van, cada passageiro pagará mais \nR$2,00 por lugar vago. \n \nSendo x o número de lugares vagos, a expres-\nsão que representa o valor arrecadado V(x), em \nreais, pelo dono da van, para uma viagem até a \ncapital é: \n \nA) V(x) = 902x \nB) V(x) = 930x \nC) V(x) = 900 + 30x \nD) V(x) = 60x + 2x² \nE) V(x) = 900 - 30x - 2x²",
    "alternativas": {
      "C": "V(x) = 900 + 30x",
      "D": "V(x) = 60x + 2x²",
      "E": "V(x) = 900 - 30x - 2x²",
      "B": "V(x) = 930x"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 705,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0707",
    "numero": 2207,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "O sindicato de trabalhadores de uma empresa \nsugere que o piso salarial da classe seja de \nR$1800,00, propondo um aumento percentual \nfixo por cada ano dedicado ao trabalho. A ex-\npressão que corresponde à proposta salarial (s), \nem função do tempo de serviço (t), em anos, é \ns(t) = 1800 . (1,03)t. \n \nDe acordo com a proposta do sindicato, o salá-\nrio de um profissional dessa empresa com 2 \nanos de tempo de serviço será, em reais, \n \nA) 7.416,00. \nB) 3.819,24. \nC) 3.709,62. \nD) 3.708,00. \nE) 1.909,62.",
    "alternativas": {
      "E": "1.909,62.",
      "A": "7.416,00.",
      "B": "3.819,24.",
      "D": "3.708,00."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 707,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0708",
    "numero": 2208,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "O modelo predador-presa foi proposto de forma \nindependente por Alfred J. Lotka, em 1925, e \nVito Volterra, em 1926. Esse modelo descreve a \ninteração entre duas espécies, sendo que uma \ndelas dispõe de alimentos para sobreviver (pre-\nsa) e a outra se alimenta da primeira (predador). \nConsidere que o gráfico representa uma intera-\nção predador-presa, relacionando a população \ndo predador com a população da sua presa ao \nlongo dos anos. \n \n \n \nDe acordo com o gráfico, nos primeiros quaren-\nta anos, quantas vezes a população do preda-\ndor se igualou à da presa? \n \nA) 2 \nB) 3 \nC) 4 \nD) 5 \nE) 9",
    "alternativas": {
      "B": "3",
      "C": "4",
      "E": "9",
      "A": "2"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 708,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0709",
    "numero": 2209,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "A bandeira de um estado é formada por cinco \nfaixas, A, B, C, D e E, dispostas conforme a \nfigura. \n \n \n \nDeseja-se pintar cada faixa com uma das cores \nverde, azul ou amarelo, de tal forma que faixas \nadjacentes não sejam pintadas com a mesma \ncor. \nO cálculo do número de possibilidades distintas \nde se pintar essa bandeira, com a exigência \nacima, é: \n \nA) 1 x 2 x 1 x 1 x 2. \nB) 3 x 2 x 1 x 1 x 2. \nC) 3 x 2 x 1 x 1 x 3. \nD) 3 x 2 x 1 x 2 x 2. \nE) 3 x 2 x 2 x 2 x 2.",
    "alternativas": {
      "D": "3 x 2 x 1 x 2 x 2.",
      "A": "1 x 2 x 1 x 1 x 2.",
      "B": "3 x 2 x 1 x 1 x 2.",
      "C": "3 x 2 x 1 x 1 x 3."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 709,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0710",
    "numero": 2210,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Um artesão fabrica vários tipos de potes cilíndri-\ncos. Mostrou a um cliente um pote de raio de \nbase a e altura b. Esse cliente, por sua vez, \nquer comprar um pote com o dobro do volume \ndo pote apresentado. O artesão diz que possui \npotes com as seguintes dimensões: \n \n \nPote I: raio a e altura 2b \n \nPote II: raio 2a e altura b \n \nPote III: raio 2a e altura 2b \n \nPote IV: raio 4a e altura b \n \nPote V: raio 4a e altura 2b \n \nO pote que satisfaz a condição imposta pelo \ncliente é o: \n \nA) I. \nB) II. \nC) III. \nD) IV. \nE) V.",
    "alternativas": {
      "C": "III.",
      "D": "IV.",
      "E": "V.",
      "A": "I."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 710,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0711",
    "numero": 2211,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Atendendo à encomenda de um mecânico, um \nsoldador terá de juntar duas barras de metais \ndiferentes. A solda utilizada tem espessura de \n18 milímetros, conforme ilustrado na figura. \n \n \n \nQual o comprimento, em metros, da peça resul-\ntante após a soldagem? \n \nA) 2,0230 \nB) 2,2300 \nC) 2,5018 \nD) 2,5180 \nE) 2,6800",
    "alternativas": {
      "A": "2,0230",
      "C": "2,5018",
      "D": "2,5180",
      "E": "2,6800"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 711,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0712",
    "numero": 2212,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Uma fábrica brasileira de exportação de peixes \nvende para o exterior atum em conserva, em \ndois tipos de latas cilíndricas: uma de altura \nigual a 4 cm e raio 6 cm, e outra de altura des-\nconhecida e raio de 3 cm, respectivamente, \nconforme a figura. Sabe-se que a medida do \nvolume da lata que possui raio maior, V1, é 1,6 \nvezes a medida do volume da lata que possui \nraio menor, V2. \n \n \nA medida da altura desconhecida vale: \n \nA) 8 cm. \nB) 10 cm. \nC) 16 cm. \nD) 20 cm. \nE) 40 cm.",
    "alternativas": {
      "D": "20 cm.",
      "E": "40 cm.",
      "A": "8 cm.",
      "B": "10 cm."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 712,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0713",
    "numero": 2213,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Uma empresa que embala seus produtos em \ncaixas de papelão, na forma de hexaedro regu-\nlar, deseja que seu logotipo seja impresso nas \nfaces opostas pintadas de cinza, conforme a \nfigura: \n \n \nA gráfica que fará as impressões dos logotipos \napresentou as seguintes sugestões planificadas: \n \n \n \n \nQue opção sugerida pela gráfica atende ao de-\nsejo da empresa? \n \nA) I \nB) II \nC) III \nD) IV \nE) V",
    "alternativas": {
      "C": "III",
      "E": "V",
      "A": "I",
      "B": "II"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 713,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0714",
    "numero": 2214,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Um técnico precisa consertar o termostato do \naparelho de ar-condicionado de um escritório, \nque está desregulado. A temperatura T, em \ngraus Celsius, no escritório, varia de acordo \ncom a função T(h) = A + B sen (\n𝜋\n12 (h - 12)), \nsendo h o tempo, medido em horas, a partir da \nmeia-noite (0 ≤ h < 24) e A e B os parâmetros \nque o técnico precisa regular. Os funcionários \ndo escritório pediram que a temperatura máxima \nfosse 26°C, a mínima 18°C, e que durante a \ntarde a temperatura fosse menor do que durante \na manhã. \n \nQuais devem ser os valores de A e de B para \nque o pedido dos funcionários seja atendido? \n \nA) A = 18 e B = 8 \nB) A = 22 e B = -4 \nC) A = 22 e B = 4 \nD) A = 26 e B = -8 \nE) A = 26 e B = 8",
    "alternativas": {
      "A": "A = 18 e B = 8",
      "B": "A = 22 e B = -4",
      "C": "A = 22 e B = 4",
      "D": "A = 26 e B = -8"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 714,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0715",
    "numero": 2215,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Num campeonato de futebol de 2012, um time \nsagrou-se campeão com um total de 77 pontos \n(P) em 38 jogos, tendo 22 vitórias (V), 11 empa-\ntes (E) e 5 derrotas (D). No critério adotado para \nesse ano, somente as vitórias e empates têm \npontuações positivas e inteiras. As derrotas têm \nvalor zero e o valor de cada vitória é maior que \no valor de cada empate.  \n \nUm torcedor, considerando a fórmula da soma \nde pontos injusta, propôs aos organizadores do \ncampeonato que, para o ano de 2013, o time \nderrotado em cada partida perca 2 pontos, privi-\nlegiando os times que perdem menos ao longo \ndo campeonato. Cada vitória e cada empate \ncontinuariam com a mesma pontuação de 2012.  \n \nQual a expressão que fornece a quantidade de \npontos (P), em função do número de vitórias \n(V), do número de empates (E) e do número de \nderrotas (D), no sistema de pontuação proposto \npelo torcedor para o ano de 2013? \n \nA) P = 3V + E \nB) P = 3V - 2D \nC) P = 3V + E - D \nD) P = 3V + E - 2D \nE) P = 3V + E + 2D",
    "alternativas": {
      "B": "P = 3V - 2D",
      "C": "P = 3V + E - D",
      "D": "P = 3V + E - 2D",
      "E": "P = 3V + E + 2D"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 715,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0716",
    "numero": 2216,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "O gráfico mostra a variação percentual do valor do Produto Interno Bruto (PIB) do Brasil, por trimestre, \nem relação ao trimestre anterior: \nDe acordo com o gráfico, no período considera-\ndo, o trimestre em que o Brasil teve o maior \nvalor do PIB foi o: \n \nA) segundo trimestre de 2009. \nB) quarto trimestre de 2009. \nC) terceiro trimestre de 2010. \nD) quarto trimestre de 2010. \nE) primeiro trimestre de 2011.",
    "alternativas": {
      "A": "segundo trimestre de 2009.",
      "C": "terceiro trimestre de 2010.",
      "D": "quarto trimestre de 2010.",
      "E": "primeiro trimestre de 2011."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 716,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0717",
    "numero": 2217,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "A Organização Mundial da Saúde (OMS) reco-\nmenda que o consumo diário de sal de cozinha \nnão exceda 5 g. Sabe-se que o sal de cozinha é \ncomposto por 40% de sódio e 60% de cloro. \nQual é a quantidade máxima de sódio proveni-\nente do sal de cozinha, recomendada pela \nOMS, que uma pessoa pode ingerir por dia? \n \nA) 1250 mg \nB) 2000 mg \nC) 3000 mg \nD) 5000 mg \nE) 12500 mg",
    "alternativas": {
      "E": "12500 mg",
      "A": "1250 mg",
      "B": "2000 mg",
      "D": "5000 mg"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 717,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0718",
    "numero": 2218,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Um fornecedor vendia caixas de leite a um su-\npermercado por R$ 1,50 a unidade. O super-\nmercado costumava comprar 3 000 caixas de \nleite por mês desse fornecedor. Uma forte seca, \nocorrida na região onde o leite é produzido, \nforçou o fornecedor a encarecer o preço de \nvenda em 40%. O supermercado decidiu então \ncortar em 20% a compra mensal dessas caixas \nde leite. Após essas mudanças, o fornecedor \nverificou que sua receita nas vendas ao super-\nmercado tinha aumentado. \n \nO aumento da receita nas vendas do fornece-\ndor, em reais, foi de: \n \nA) 540. \nB) 600. \nC) 900. \nD) 1260. \nE) 1500.",
    "alternativas": {
      "B": "600.",
      "C": "900.",
      "E": "1500.",
      "A": "540."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 718,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0719",
    "numero": 2219,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Cinco amigos marcaram uma viagem à praia em \ndezembro. Para economizar, combinaram de ir \nnum único carro. Cada amigo anotou quantos \nquilômetros seu carro fez, em média, por litro de \ngasolina, nos meses de setembro, outubro e \nnovembro. Ao final desse trimestre, calcularam \na média dos três valores obtidos para escolhe-\nrem o carro mais econômico, ou seja, o que \nteve a maior média. Os dados estão represen-\ntados na tabela: \n \n \nQual carro os amigos deverão escolher para a \nviagem? \n \nA) I \nB) II \nC) III \nD) IV \nE) V",
    "alternativas": {
      "A": "I",
      "B": "II",
      "C": "III",
      "D": "IV"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 719,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0720",
    "numero": 2220,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Um paciente precisa ser submetido a um trata-\nmento, sob orientação médica, com determina-\ndo medicamento. Há cinco possibilidades de \nmedicação, variando a dosagem e o intervalo de \ningestão do medicamento. As opções apresen-\ntadas são: \n \nA: um comprimido de 400 mg, de 3 em 3 \nhoras, durante 1 semana; \nB: um comprimido de 400 mg, de 4 em 4 \nhoras, durante 10 dias; \nC: um comprimido de 400 mg, de 6 em 6 \nhoras, durante 2 semanas; \nD: um comprimido de 500 mg, de 8 em 8 \nhoras, durante 10 dias; \nE: um comprimido de 500 mg, de 12 em 12 \nhoras, durante 2 semanas. \n \nPara evitar efeitos colaterais e intoxicação, a \nrecomendação é que a quantidade total de \nmassa da medicação ingerida, em miligramas, \nseja a menor possível. \n \nSeguindo a recomendação, deve ser escolhida \na opção: \n \nA) A. \nB) B. \nC) C. \nD) D. \nE) E.",
    "alternativas": {
      "B": "B.",
      "C": "C.",
      "D": "D.",
      "E": "E."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2015.2",
    "numeroOriginal": 720,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0721",
    "numero": 2221,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Para uma feira de ciências, dois projéteis de \nfoguetes, A e B, estão sendo construídos para \nserem lançados. O planejamento é que eles \nsejam lançados juntos, com o objetivo de o pro-\njétil B interceptar o A quando esse alcançar sua \naltura máxima. Para que isso aconteça, um dos \nprojéteis descreverá uma trajetória parabólica, \nenquanto o outro irá descrever uma trajetória \nsupostamente retilínea. O gráfico mostra as \nalturas alcançadas por esses projéteis em fun-\nção do tempo, nas simulações realizadas. \n \n \n \nCom base nessas simulações, observou-se que \na trajetória do projétil B deveria ser alterada \npara que o objetivo fosse alcançado. \n \nPara alcançar o objetivo, o coeficiente angular \nda reta que representa a trajetória de B deverá: \n \nA) diminuir em 2 unidades. \nB) diminuir em 4 unidades. \nC) aumentar em 2 unidades. \nD) aumentar em 4 unidades. \nE) aumentar em 8 unidades.",
    "alternativas": {
      "E": "aumentar em 8 unidades.",
      "A": "diminuir em 2 unidades.",
      "C": "aumentar em 2 unidades.",
      "D": "aumentar em 4 unidades."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 721,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0722",
    "numero": 2222,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Para a construção de isolamento acústico numa \nparede cuja área mede 9 m2, sabe-se que, se a \nfonte sonora estiver a 3 m do plano da parede, o \ncusto é de R$ 500,00. Nesse tipo de isolamento, \na espessura do material que reveste a parede é \ninversamente proporcional ao quadrado da dis-\ntância até a fonte sonora, e o custo é diretamen-\nte proporcional ao volume do material do reves-\ntimento. \n \nUma expressão que fornece o custo para reves-\ntir uma parede de área A (em metro quadrado), \nsituada a D metros da fonte sonora, é: \n \nA) \n500 ∙ 81\nA ∙ D2  \n \nB) \n500 ∙ A\nD2\n \n \nC) \n500 ∙ D2\nA\n \n \nD) \n500 ∙ A ∙ D2\n81\n \n \nE) \n500 ∙ 3 ∙ D2\nA",
    "alternativas": {
      "A": "500 ∙ 81 A ∙ D2",
      "B": "500 ∙ A D2",
      "D": "500 ∙ A ∙ D2 81",
      "E": "500 ∙ 3 ∙ D2 A"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 722,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0723",
    "numero": 2223,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "A fim de acompanhar o crescimento de crian-\nças, foram criadas pela Organização Mundial da \nSaúde (OMS) tabelas de altura, também adota-\ndas pelo Ministério da Saúde do Brasil. Além de \ninformar os dados referentes ao índice de cres-\ncimento, a tabela traz gráficos com curvas, \napresentando padrões de crescimento estipula-\ndos pela OMS. \n \nO gráfico apresenta o crescimento de meninas, \ncuja análise se dá pelo ponto de intersecção \nentre o comprimento, em centímetro, e a idade, \nem mês completo e ano, da criança. \n \n \n \nUma menina aos 3 anos de idade tinha altura de \n85 centímetros e aos 4 anos e 4 meses sua \naltura chegou a um valor que corresponde a um \nponto exatamente sobre a curva p50. \n \nQual foi o aumento percentual da altura dessa \nmenina, descrito com uma casa decimal, no \nperíodo considerado? \n \nA) 23,5% \nB) 21,2% \nC) 19,0% \nD) 11,8% \nE) 10,0%",
    "alternativas": {
      "C": "19,0%",
      "E": "10,0%",
      "A": "23,5%",
      "B": "21,2%"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 723,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0724",
    "numero": 2224,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Uma cisterna de 6000L foi esvaziada em um \nperíodo de 3h. Na primeira hora foi utilizada \napenas uma bomba, mas nas duas horas se-\nguintes, a fim de reduzir o tempo de esvazia-\nmento, outra bomba foi ligada junto com a pri-\nmeira.  \n \nO gráfico, na sequência da questão, formado \npor dois segmentos de reta, mostra o volume de \nágua presente na cisterna, em função do tempo. \n \n \nQual é a vazão, em litro por hora, da bomba que \nfoi ligada no início da segunda hora? \n \nA) 1000 \nB) 1250 \nC) 1500 \nD) 2000 \nE) 2500",
    "alternativas": {
      "B": "1250",
      "C": "1500",
      "D": "2000",
      "A": "1000"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 724,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0725",
    "numero": 2225,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "O cultivo de uma flor rara só é viável se do mês \ndo plantio para o mês subsequente o clima da \nregião possuir as seguintes peculiaridades: \n \n• a variação do nível de chuvas (pluviosidade), \nnesses meses, não for superior a 50 mm; \n \n• a temperatura mínima, nesses meses, for su-\nperior a 15°C; \n \n• ocorrer, nesse período, um leve aumento não \nsuperior a 5 °C na temperatura máxima. \nUm floricultor, pretendendo investir no plantio \ndessa flor em sua região, fez uma consulta a um \nmeteorologista que lhe apresentou o gráfico \ncom as condições previstas para os 12 meses \nseguintes nessa região. \n \n \n \nCom base nas informações do gráfico, o floricul-\ntor verificou que poderia plantar essa flor rara. O \nmês escolhido para o plantio foi: \n \nA) janeiro. \nB) fevereiro. \nC) agosto. \nD) novembro. \nE) dezembro.",
    "alternativas": {
      "A": "janeiro.",
      "C": "agosto.",
      "D": "novembro.",
      "E": "dezembro."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 725,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0726",
    "numero": 2226,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "O procedimento de perda rápida de “peso” é \ncomum entre os atletas dos esportes de comba-\nte. Para participar de um torneio, quatro atletas \nda categoria até 66 kg, Peso-Pena, foram sub-\nmetidos a dietas balanceadas e atividades físi-\ncas. Realizaram três “pesagens” antes do início \ndo torneio. Pelo regulamento do torneio, a pri-\nmeira luta deverá ocorrer entre o atleta mais \nregular e o menos regular quanto aos “pesos”. \nAs informações com base nas pesagens dos \natletas estão no quadro. \n \n \n \nApós as três “pesagens”, os organizadores do \ntorneio informaram aos atletas quais deles se \nenfrentariam na primeira luta. \n \nA primeira luta foi entre os atletas: \n \nA) I e III. \nB) l e IV. \nC) II e III. \nD) II e IV. \nE) III e IV.",
    "alternativas": {
      "A": "I e III.",
      "C": "II e III.",
      "D": "II e IV.",
      "E": "III e IV."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 726,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0727",
    "numero": 2227,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "De forma geral, os pneus radiais trazem em sua \nlateral uma marcação do tipo abc/deRfg, como \n185/65R15. Essa marcação identifica as medi-\ndas do pneu da seguinte forma: \n \n• abc é a medida da largura do pneu, em milí-\nmetro; \n \n• de é igual ao produto de 100 pela razão entre \na medida da altura (em milímetro) e a medida \nda largura do pneu (em milímetro); \n \n• R significa radial; \n \n• fg é a medida do diâmetro interno do pneu, em \npolegada. \n \nA figura ilustra as variáveis relacionadas com \nesses dados. \n \n \nO proprietário de um veículo precisa trocar os \npneus de seu carro e, ao chegar a uma loja, é \ninformado por um vendedor que há somente \npneus com os seguintes códigos: 175/65R15, \n175/75R15, \n175/80R15, \n185/60R15 \ne \n205/55R15.  \n \nAnalisando, juntamente com o vendedor, as \nopções de pneus disponíveis, concluem que o \npneu mais adequado para seu veículo é o que \ntem a menor altura. \n \nDesta forma, o proprietário do veículo deverá \ncomprar o pneu com a marcação: \n \nA) 205/55R15. \nB) 175/65R15. \nC) 175/75R15. \nD) 175/80R15. \nE) 185/60R15.",
    "alternativas": {
      "E": "185/60R15.",
      "A": "205/55R15.",
      "B": "175/65R15.",
      "D": "175/80R15."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 727,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  }
];